import * as React from 'react';
import { FaSyncAlt as FaRefresh } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { Link as ExternalLink } from 'ui';
import { getSctwLink } from 'app/infrastructure/hosting';
import { When } from './when';
import { hasOtherToolsAccess, canUseSystemConfigurationTool } from './menu-access-guards';
import { MenuAccess } from '../../../types';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  menuAccess: MenuAccess;
  onRefreshCache: (event: React.MouseEvent) => void;
  onRegenerateAggregatedEnv: (event: React.MouseEvent) => void;
  onRegenerateAggregatedRisk: (event: React.MouseEvent) => void;
}

export const ToolsOtherMenuItem = ({
  translation,
  menuAccess,
  onRefreshCache,
  onRegenerateAggregatedEnv,
  onRegenerateAggregatedRisk
}: Props) => (
  <When condition={hasOtherToolsAccess(menuAccess)}>
    <li>
      <input type="checkbox" id="mobile-admin-other-tools" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <FaRefresh className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.other_tools}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-admin-other-tools">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <When condition={menuAccess.refreshCache}>
          <li className={styles.child}>
            <button type="button" id="nav-logout-button" className="list-group-item" onClick={onRefreshCache}>
              <span className={styles.navItemText}>{translation.refresh_cache_title}</span>
            </button>
          </li>
        </When>

        <When condition={menuAccess.regenerateAggregatedData}>
          <li className={styles.child}>
            <button type="button" onClick={onRegenerateAggregatedEnv} className="list-group-item">
              <span className={`${styles.navItemText} ${styles.small}`}>
                {translation.regenerate_aggregated_environmental_data}
              </span>
            </button>
          </li>
        </When>

        <When condition={menuAccess.regenerateAggregatedData}>
          <li className={styles.child}>
            <button type="button" onClick={onRegenerateAggregatedRisk} className="list-group-item">
              <span className={`${styles.navItemText} ${styles.small}`}>
                {translation.regenerate_aggregated_risk_data}
              </span>
            </button>
          </li>
        </When>

        <When condition={canUseSystemConfigurationTool(menuAccess)}>
          <li className={styles.child}>
            <ExternalLink url={getSctwLink()} className={'list-group-item'}>
              <span className={`${styles.navItemText} ${styles.small}`}>
                {translation.system_configuration_tool}
              </span>
            </ExternalLink>
          </li>
        </When>
      </ul>
    </li>
  </When>
);
